<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <div class="container start-page">
      <h1 class="section-header">
        {{ "MEDICAL_APPEAL_HEADER" | globalTranslate }}
      </h1>
      <hr />
      <!-- Case Selection Section -->
      <div>
        <!-- Single Case - Display Only -->
        @if (!multipleCase) {
        <p>
          <span class="label-section">{{
            "CASE_NUMBER" | globalTranslate
          }}</span
          >&nbsp;
          <span>{{ singleCaseNum }}</span>
        </p>
        }
        <!-- Multiple Cases - Dropdown with Select Button -->
        @if (multipleCase) {
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_CASE_SELECTION' | globalTranslate }}"
          class="label-section mutliple-case-section"
        >
          <div class="row">
            <div class="p-2 pb-0">
              <select
                style="height: 38px"
                class="appeal_case_num"
                nhTranslate
                name="appealCaseNumber"
                [items]="caseNumberList"
                [attr.aria-label]="
                  'MEDICAL_APPEAL_CASE_SELECTION' | globalTranslate
                "
                formControlName="appealCaseNumber"
                (change)="appealCaseFor()"
              ></select>
            </div>
            <div class="p-2"></div>
            <div class="p-2">
              <button
                id="showSelectMembers"
                (click)="showSelectMembers()"
                class="btn btn-secondary btn-search"
                [disabled]="!enableSearch"
              >
                {{ searchSelect | globalTranslate }}
              </button>
            </div>
          </div>
        </nh-field>
        }
      </div>
      <!-- Member Selection Section -->
      @if (showSelectAppelantsTable) {
      <div [formGroup]="getControl('data.tccMedAplRqstInfoData')">
        <h2 class="section-header">
          {{ "SELECT_HOUSEHOLD_MEMBER" | globalTranslate }}
        </h2>
        <hr />
        <!-- Dropdown: Self / Other Household Member -->
        <nh-field
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_FILING_FOR' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="filingMaForCd"
            [items]="
              tableCodeValue(
                'MEDAPLFILINGFOR',
                'data.tccMedAplRqstInfoData.filingMaForCd'
              )
            "
            [attr.aria-label]="'MEDICAL_APPEAL_FILING_FOR' | globalTranslate"
            (change)="filingCaseFor()"
            [attr.disabled]="disableFilingDropdown"
            formControlName="filingMaForCd"
          ></select>
        </nh-field>
        <nh-alert
          type="warning"
          [isOpen]="showOtherMemberWarning"
          class="investigate-banner"
        >
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span class="visually-hidden">{{
                "Alert" | globalTranslate
              }}</span>
              <span
                [innerHtml]="'OTHER_MEMBER_BANNER' | globalTranslate"
              ></span>
            </div>
          </div>
        </nh-alert>
        <!-- Desktop Table -->
        @if (enableTable) {
        <div class="d-none d-lg-block">
          <ngx-datatable
            class="bootstrap striped"
            #table
            [rows]="selectAppelantsRows"
            columnMode="force"
            [headerHeight]="'auto'"
            [footerHeight]="50"
            [rowHeight]="'auto'"
          >
            <!-- Name & Person ID Columns -->
            @for (col of selectAppelantsColumns; track col) {
            <ngx-datatable-column
              [cellClass]="'my-auto'"
              [name]="col.name | globalTranslate"
              [prop]="col.prop"
            >
            </ngx-datatable-column>
            }
            <!-- File Medical Appeal Column (Radio Button) -->
            <ngx-datatable-column
              [cellClass]="'my-auto'"
              [name]="FileMedicalAppeal | globalTranslate"
            >
              <ng-template ngx-datatable-cell-template let-row="row">
                <!-- Show radio button if eligible -->
                @if (row?.eligForMatsAppealSw === 'Y') {
                <div style="position: relative; left: -22%; text-align: center;">
                  <input
                  type="radio"
                  name="selectedMember"
                  [checked]="row.selected"
                  [attr.aria-label]="
                    'Select ' + row.memberName + ' for medical appeal'"
                  (change)="selectMember(row)"
                  [value]="row.indvid"
                />
                </div>
                }
                <!-- Show ineligibility message if not eligible -->
                @if (row.eligForMatsAppealSw === 'N') {
                <span
                  [innerHTML]="
                    'MEDICAL_APPEAL_INELIGIBLE_TEXT' | globalTranslate
                  "
                ></span>
                }
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        }
        <!-- Mobile View -->
        @if (enableTable) {
        <div class="nh-table-mobile d-lg-none">
          @for (row of selectAppelantsRows; track row) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ selectAppelantsColumns[0].name | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">{{ row.memberName }}</div>
            <br />
            <div class="mobile-table-header">
              {{ selectAppelantsColumns[1].name | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">{{ row.personId }}</div>
            <br />
            <div class="mobile-table-header">
              {{ FileMedicalAppeal | globalTranslate }}
            </div>
            <hr />
            <!-- Show SELECT button if eligible -->
            @if (row.eligForMatsAppealSw === 'Y') {
            <button
              (click)="selectMember(row)"
              class="btn btn-secondary btn-search"
            >
              {{
                row.selected
                  ? (selected | globalTranslate)
                  : (select | globalTranslate)
              }}
            </button>
            }
            <!-- Show ineligibility message if not eligible -->
            @if (row.eligForMatsAppealSw === 'N') {
            <div
              class="mobile-table-data"
              [innerHTML]="'MEDICAL_APPEAL_INELIGIBLE_TEXT' | globalTranslate"
            ></div>
            }
            <br />
          </div>
          }
        </div>
        }
      </div>
      }
      <!-- Filer Contact Information (visible when a member is selected) -->
      @if (showFilerContactInfo) {
      <section [formGroup]="getControl('data.tccMedAplRqstInfoData')">
        <nh-field
          id="apr_relationship"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'FILER_RELATIONSHIP_WITH_MEMBER' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="callerRelationshipCd"
            [items]="
              tableCodeValue(
                'CALLERRELATIONSHIP',
                'data.tccMedAplRqstInfoData.callerRelationshipCd'
              )
            "
            [attr.aria-label]="
              'FILER_RELATIONSHIP_WITH_MEMBER' | globalTranslate
            "
            formControlName="callerRelationshipCd"
          ></select>
        </nh-field>
        <h2 class="section-header">
          {{ "FILER_CONTACT_INFO_HEADER" | globalTranslate }}
        </h2>
        <hr />
        <div class="row g-3">
          <div class="col-sm-6">
            <nh-field
              id="apr_firstName"
              [isRow]="true"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'MA_FIRST_NAME' | globalTranslate }}"
            >
              <input
                type="text"
                name="callerFstName"
                formControlName="callerFstName"
                class="form-control"
                maxlength="45"
                [attr.aria-label]="'MA_FIRST_NAME' | globalTranslate"
              />
            </nh-field>
          </div>
          <div class="col-sm-6">
            <nh-field
              id="apr_lastName"
              [isRow]="true"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'LAST_NAME' | globalTranslate }}"
            >
              <input
                type="text"
                name="callerLastName"
                formControlName="callerLastName"
                class="form-control"
                maxlength="45"
                [attr.aria-label]="'LAST_NAME' | globalTranslate"
              />
            </nh-field>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-sm-7 col-lg-4">
            <nh-field
              id="apr_phoneNumber"
              [isRow]="true"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'PHONE_NUMBER1' | globalTranslate }}"
            >
              <input
                type="text"
                name="callerPhnNum"
                formControlName="callerPhnNum"
                class="form-control"
                mask="000-000-0000"
                placeholder="XXX-XXX-XXXX"
                [attr.aria-label]="'PHONE_NUMBER1' | globalTranslate"
              />
            </nh-field>
          </div>
          <div class="col-sm-5 col-lg-4">
            <nh-field
              id="apr_extension"
              [isRow]="true"
              [mandatory]="false"
              [attr.aria-required]="false"
              label="{{ 'EXTENSION' | globalTranslate }}"
            >
              <input
                type="text"
                name="callerPhnNumExt"
                formControlName="callerPhnNumExt"
                class="form-control"
                maxlength="6"
                mask="0*"
                [attr.aria-label]="'EXTENSION' | globalTranslate"
              />
            </nh-field>
          </div>
        </div>
        <nh-field
          id="apr_primaryLanguage"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_PRIMARY_LANGUAGE' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="callerPrimLangCd"
            [items]="
              tableCodeValue(
                'SPOKEHEARLANGUAGE',
                'data.tccMedAplRqstInfoData.callerPrimLangCd'
              )
            "
            [attr.aria-label]="
              'MEDICAL_APPEAL_PRIMARY_LANGUAGE' | globalTranslate
            "
            formControlName="callerPrimLangCd"
            (change)="onPrimaryLanguageChange()"
          ></select>
        </nh-field>
        @if
        (getControl('data.tccMedAplRqstInfoData.callerPrimLangCd').value?.code
        === 'OT') {
        <nh-field
          [mandatory]="false"
          label="{{ 'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate }}"
          class="label-section"
        >
          <input
            type="text"
            alphabetic
            name="callerPrimLangOther"
            class="form-control"
            [attr.aria-label]="
              'MEDICAL_APPEAL_LANGUAGE_DETAILS' | globalTranslate
            "
            formControlName="callerPrimLangOther"
            maxlength="30"
          />
        </nh-field>
        }
        <nh-field
          id="apr_memberPresent"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_MEMBER_PRESENT' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="isMemberPresentSw"
            [items]="
              tableCodeValue(
                'YESNO',
                'data.tccMedAplRqstInfoData.isMemberPresentSw'
              )
            "
            [attr.aria-label]="
              'MEDICAL_APPEAL_MEMBER_PRESENT' | globalTranslate
            "
            formControlName="isMemberPresentSw"
          ></select>
        </nh-field>
        <!-- Address Section -->
        <div
          [formGroup]="
            getControl('data.tccMedAplRqstInfoData.medAppealAddress')
          "
        >
          <nh-field
            id="apr_addressFormat"
            name="addressFormat"
            [mandatory]="true"
            [attr.aria-required]="true"
            label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
            class="label-section"
          >
            <nh-popover
              class="ps-1"
              content="{{ 'CASE_HEAD_POPOVER_TEXT' | globalTranslate }}"
            ></nh-popover>
            <select
              nhTranslate
              name="addressFormat"
              [items]="
                tableCodeValue(
                  'ADDRESSFORMATTYPES',
                  'data.tccMedAplRqstInfoData.medAppealAddress.addressFormat'
                )
              "
              [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
              formControlName="addressFormat"
            ></select>
          </nh-field>
          <nh-name-address
            [addressname]="'apr_medAppealAddress'"
            [addressFormat]="
              getControl(
                'data.tccMedAplRqstInfoData.medAppealAddress.addressFormat'
              )
            "
            [address]="
              getControl('data.tccMedAplRqstInfoData.medAppealAddress.address')
            "
            [stateDefault]="true"
            [isAssistingPerson]="false"
            [addressLine1MaxLength]="46"
            [addressLine2MaxLength]="14"
            [tables]="tables"
          >
          </nh-name-address>
        </div>
        <nh-field
          id="apr_addressSame"
          [mandatory]="true"
          [attr.aria-required]="true"
          label="{{ 'MEDICAL_APPEAL_FILER_ADDRESS_SAME' | globalTranslate }}"
          class="label-section"
        >
          <select
            nhTranslate
            name="resSameAsMailAddrSw"
            [items]="
              tableCodeValue(
                'YESNO',
                'data.tccMedAplRqstInfoData.resSameAsMailAddrSw'
              )
            "
            [attr.aria-label]="
              'MEDICAL_APPEAL_FILER_ADDRESS_SAME' | globalTranslate
            "
            formControlName="resSameAsMailAddrSw"
          ></select>
        </nh-field>
      </section>
      }
    </div>
  </section>
</nh-form>